module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-full-3a6f44e682b29b586fc0818d780577ac.svg";